import './styles.scss';
import fieldsImageE from '../../assets/fields-image-e.JPG'


function Fields() {

    return (
        <div className="container-fields">
            <div className='fields-content'>
                <h1>Áreas de Atuação</h1>
                <ul>
                    <li><i className="fa-solid fa-notes-medical"></i>Varizes</li>
                    <li><i className="fa-solid fa-notes-medical"></i>Vasinhos</li>
                    <li><i className="fa-solid fa-notes-medical"></i>Trombose</li>
                    <li><i className="fa-solid fa-notes-medical"></i>Check-up Vascular</li>
                </ul>
                <a href="https://wa.me/5571997303062" target="_blank" rel="noopener noreferrer">Agendar Consulta</a>
            </div>

            <div className='fields-image'>
                <img src={fieldsImageE} alt='Dra. Lais' />
            </div>

        </div>
    );
}

export default Fields;
